import React, { useState } from "react";
import { arabicAlphabets } from "../data/arabicAlphabets";

function AlphabetGame() {
  const [score, setScore] = useState(0);
  const [shuffledAlphabets, setShuffledAlphabets] = useState(shuffleArray(arabicAlphabets));
  const [selectedLetter, setSelectedLetter] = useState(null);

  // Shuffle function to randomize alphabets
  function shuffleArray(array) {
    return array.sort(() => Math.random() - 0.5);
  }

  // Handle alphabet click event
  const handleLetterClick = (letter) => {
    if (letter === selectedLetter) {
      setScore(score + 1); // Increase score if the user clicks the correct letter
      setShuffledAlphabets(shuffleArray(arabicAlphabets)); // Shuffle the letters again
    } else {
      alert("Try Again!"); // If clicked letter is wrong
    }
  };

  // Function to start the game (or reset)
  const startGame = () => {
    setScore(0);
    setShuffledAlphabets(shuffleArray(arabicAlphabets));
    setSelectedLetter(arabicAlphabets[Math.floor(Math.random() * arabicAlphabets.length)]);
  };

  // Function to speak the letter
  const speak = (letter) => {
    if (window.responsiveVoice) {
      window.responsiveVoice.speak(letter, "Arabic Male");
    }
  };

  return (
    <div className="p-6 md:p-10">
      <h2 className="text-3xl font-bold text-center text-blue-700 mb-6">Arabic Alphabet Game</h2>
      <p className="text-xl text-center mb-8">Click on the alphabet that matches the sound!</p>
      
      <div className="mb-6 text-center">
        <h3 className="text-2xl font-semibold text-blue-600 mb-3">Score: {score}</h3>
        <button
          onClick={startGame}
          className="bg-blue-600 text-white p-3 rounded-md hover:bg-blue-700 transition"
        >
          Start Game
        </button>
      </div>

      {selectedLetter && (
        <div className="text-center mb-8">
          <h3 className="text-2xl font-semibold text-blue-600 mb-3">
            Find this letter: {selectedLetter}
          </h3>
          <button
            className="bg-green-600 text-white p-3 rounded-md hover:bg-green-700 transition"
            onClick={() => speak(selectedLetter)}
          >
            Listen to the Letter
          </button>
        </div>
      )}

      <div className="grid grid-cols-4 gap-6">
        {shuffledAlphabets.map((letter, index) => (
          <div
            key={index}
            className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition text-center cursor-pointer"
            onClick={() => handleLetterClick(letter)}
          >
            <div className="text-5xl text-blue-700">{letter}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AlphabetGame;
